type TransferWithPrices = {
  outgoingPrice: number;
  incomingPrice: number;
};

/**
 * Sorts transfers so budget-freeing ones (net positive) come first. Prevents
 * intermediate budget violations when the backend validates transfers
 * sequentially.
 */
export const sortTransfersByBudgetImpact = <T extends TransferWithPrices>(
  transfers: T[]
): T[] =>
  [...transfers].sort(
    (a, b) =>
      b.outgoingPrice - b.incomingPrice - (a.outgoingPrice - a.incomingPrice)
  );
